// -- Imports -- //
const onbrandUtilityFunctions = require("onbrandutilityfunctions");
const moment = require("moment");
const devOptions = require("./dev-options.js"); //Development options
const onbrand_scss = require("./onbrand.scss"); //Onbrand styles
const client_scss = require("./client/client.scss"); //client styles
const {
  sideBarFiltering,
  getAllTiles,
  getSearchTerms
} = require("./custom-js/filtering.js");
// const htmlHeader = require('./includes/header.html');
// const htmlFooter = require('./includes/footer.html');
// -- Startup -- //
production ? null : onbrandUtilityFunctions.devMode(devOptions);
$("body").prepend($("#injected-header"));
$("body").append($("#injected-footer"));
window.onbrandLoaded = false;
onbrandUtilityFunctions.fixShareWidgetImproved();
onbrandUtilityFunctions.descriptionSlideUp();

if (/embedtile/gi.test(window.location.href)) {
  $("head").append(`
  <style id="embedoverride">
    .tile:not(.cta):after {
      border-bottom: 20px solid white !important;
    }
    .tile:not(.cta):before {
      border-top: 20px solid white !important;
    }
  </style>`);
}
// -- Custom Functions -- //

const spansForTileButtons = function() {
  $("a.item-link.view")
    .not(".spaned")
    .each(function(i, el) {
      $(this)
        .html(`<span class="contents">${$(this).text()}</span>`)
        .addClass("spaned");
    });
};

const homeSelected = function() {
  if ($("body").hasClass("hub-page")) {
    $(".left-nav>li:first-of-type").addClass("selected");
  }
};

const selectedUnderline = () => {
  const child = $(".selected").children("a");
  const firstChild = child.first();
  firstChild.addClass("selected_link");
  const listItems = $(".left-nav").children("li");
  for (let i = 0; i < listItems.length; i++) {
    const li = listItems[i];
    const liClasses = li.classList.contains("selected");
    if (liClasses === false) {
      const child = li.querySelector("a");
      child.classList.remove("selected_link");
    }
  }
};

const hideBreadcrumbs = () => {
  const breadcrumbs = $('a[data-page-title="Home"]');
  breadcrumbs.next().css("display", "none");
  breadcrumbs.css("display", "none");
};

const shortenTile = (source, i) => {
  if (source !== undefined) {
    const tileData = [];
    const tile = $(`.tile.${source}.with-img`);
    const avatars = tile.not(".highlight").find(".description h4.avatar");
    for (let i = 0; i < avatars.length; i++) {
      const avatar = avatars[i];
      const tile = avatar.parentNode.parentNode.dataset.id;
      const avatarText = avatar.innerText;
      const avatarLength = avatarText.length;
      if (avatarLength > 60) {
        const shorterText = avatarText.split(" ", 11);
        const newString = shorterText.join(" ");
        avatar.innerText = newString + " ...";
        const itemData = {
          id: tile,
          largeText: avatarText,
          smallText: newString
        };
        tileData.push(itemData);
      }
    }
    tile.on("mouseover", function(e) {
      const avatar = this.querySelector("h4.avatar");
      const dataId = this.dataset.id;
      tileData.forEach((x, i) => {
        if (x.id === dataId) {
          avatar.innerText = x.largeText;
        }
      });
    });
    tile.on("mouseleave", function() {
      const avatar = this.querySelector("h4.avatar");
      const dataId = this.dataset.id;
      tileData.forEach((x, i) => {
        if (x.id === dataId) {
          avatar.innerText = x.smallText + " ...";
        }
      });
    });
  }
};

const tileTitleCheck = () => {
  const tileTitle = $(".tile.with-img")
    .not(".highlight")
    .find(".description h3.h3like");
  for (let i = 0; i < tileTitle.length; i++) {
    const title = tileTitle[i];
    const titleText = title.innerText;
    if (titleText.length > 50) {
      title.style.fontSize = "18px";
    }
  }
};

/**
 * Reformats tiles to put the friendly timestamp after the title, and to
 * change the format of the friendly timestamp
 */
const formatTiles = function() {
  $(".tile")
    .not(".formatted")
    .each(function(i, el) {
      const $friendlyTimestampElement = $(this).find(".friendly-timestamp");
      const timeStamp = $friendlyTimestampElement.find("abbr").attr("title");
      const $title = $(this).find(".description h3");
      const momentTimestamp = timeStamp ? moment(timeStamp) : "";
      const $newTimestampElement = momentTimestamp
        ? $(
            `<span class="onbrand__friendlyTimestamp">${momentTimestamp.format(
              "DD MMMM YYYY"
            )}</span>`
          )
        : $(
            `<span class="onbrand__friendlyTimestamp" style="display:none"></span>`
          );
      $friendlyTimestampElement.hide();
      $newTimestampElement.insertAfter($title);
      $(".onbrand__friendlyTimestamp")
        .addClass("friendly-timestamp")
        .show();
      $(this).addClass("formatted");
    });
};

/**
 * Manages the show/hide effect of the contact us widget based on
 * where it is relative to the top-nav
 *
 */
const contactUsWidgetPopOut = function() {
  const $floater = $(".c-contact-floater");
  const $topNav = $(".top-nav");
  if ($floater.length && $topNav.length) {
    if ($floater.offset().top < $topNav.offset().top) {
      $floater.removeClass("out").addClass("in");
    } else {
      $floater.removeClass("in").addClass("out");
    }
  } else {
    return false;
  }
};

/**
 * Causes a specific cta to open in the same tab
 * (requested by customer)
 */
const openInSameTab = function() {
  $("#hub-cta-114801 a")
    .attr("target", "_self")
    .off();
};

const buildQuoteCTA = function() {
  var $cta = $(this);
  if ($cta.length) {
    $cta
      .not(".cta")
      .not(".oB_quoted")
      .each(function(index, el) {
        try {
          // Selector is always different, so normalize finding it
          var selector;
          if (
            $(this)
              .children(".description")
              .children(".long-h3").length
          ) {
            selector = ".long-h3";
          } else if (
            $(this)
              .children(".description")
              .children("h4").length
          ) {
            selector = "h4";
          } else {
            return;
          }

          // Get the string for the quote, break out the parts we need...
          // main quote text
          var ctaText = $(this)
            .children(".description")
            .children(selector)
            .text()
            .split("-");
          var quoteText = ctaText[0].trim().slice(1); // This gets rid of the first character (should be a " )

          quoteText = '<span class="quoteIcon"></span>' + quoteText; // This appends a icon of a " to replace the one we removed

          // Get the author name
          var quoteAuthor = ctaText[1].trim();

          // Get the author's sub-title (occupatiuon) IF it exists
          var quoteAuthorSub;
          if (ctaText[2]) {
            quoteAuthorSub = ctaText[2].trim();
          } else {
            quoteAuthorSub = " ";
          }

          // Build the DOM

          // Put main quote text as title
          $(this)
            .children(".description")
            .children(".h3like")
            .html(quoteText);

          // Build author element
          const $quoteAuthor = $('<p class="quoteAuthor"></p>');
          $quoteAuthor.text(quoteAuthor);
          $quoteAuthor.html(
            $quoteAuthor.html() +
              '<br><span class="authorSub">' +
              quoteAuthorSub +
              "</span>"
          );

          // Append author element
          $(this)
            .children(".description")
            .append($quoteAuthor);

          // Remove original description (we already stole its text, we don't need it anymore)
          $(this)
            .children(".description")
            .children(selector)
            .remove();

          // Add class quoted so we know not to process this tile again
          $(this).addClass("oB_quoted");
        } catch (err) {
          $(this).hide();
          console.warn("quote CTA failed to load!", this);
          console.error(err);
        }
      });
  }
};
//eslint-disable-next-line
const hubNavLangHandler = streams => {
  for (const stream in streams) {
    const streamName = streams[stream].name;
    const streamUrl = streams[stream].url;

    if ($("body").hasClass(`stream-${stream}`)) {
      $(".top-nav li.usa > a").attr("href", `${streamUrl}`);
      $(".top-nav li.usa")
        .addClass(`${streamName}`)
        .removeClass("usa");
      $(`.top-nav .lang-dropdown ul li.${streamName} a`).attr("href", "/");
      $(`.top-nav .lang-dropdown ul li.${streamName}`)
        .removeClass(`${streamName}`)
        .addClass("usa");

      $("#left-nav-phone li.japan > a");
      $("#left-nav-phone li.usa > a").attr("href", `${streamUrl}`);
      $("#left-nav-phone li.usa")
        .addClass(`${streamName}`)
        .removeClass("usa");

      $(
        `#left-nav-phone .lang-dropdown .collapsable-section ul li.${streamName} a`
      ).attr("href", "/");
      $(
        `#left-nav-phone .lang-dropdown .collapsable-section ul li.${streamName}`
      )
        .removeClass(`${streamName}`)
        .addClass("usa");
      return;
    }
  }
};

// -- Hub Events -- //
const onLoadAndPageChange = function() {
  $("body>header").addClass("page-width");
  openInSameTab();
  homeSelected();
  onbrandUtilityFunctions.blockCtaFix();
  onbrandUtilityFunctions.fadeOutItem();
  spansForTileButtons();
  hubNavLangHandler(window.languageStreams);
  tileTitleCheck();
  selectedUnderline();
  hideBreadcrumbs();
  formatTiles();
  shortenTile("twitter");
  shortenTile("facebook");
  onbrandUtilityFunctions.doIfTag("customQuote", buildQuoteCTA, function() {});
};
Hubs.Events.on("load", function() {
  if (!window.onbrandLoaded) {
    onLoadAndPageChange();
    // Add your onloads here...
    //filtering
    sideBarFiltering();
    getAllTiles();
    getSearchTerms();

    // end your onloads before here...
    window.onbrandLoaded = true;
  }
})
  .on("pageChange", function() {
    onLoadAndPageChange();
    //filtering
    sideBarFiltering();
    getAllTiles();
    getSearchTerms();
  })
  .on("itemsLoaded", function(itemIds, selectors) {
    spansForTileButtons();
    tileTitleCheck();
    formatTiles();
    shortenTile("twitter");
    shortenTile("facebook");
  })
  .on("resize", function() {
    sideCtaFix();
    addThisFix();
    contactUsWidgetPopOut();
  })
  .on("scroll", function() {
    sideCtaFix();
    addThisFix();
    onbrandUtilityFunctions.blockCtaFix();
    onbrandUtilityFunctions.fadeOutItem();
    contactUsWidgetPopOut();
  })
  .on("ctaActivate", function(ctaId) {})
  .on("ctaFormSubmitSuccess", function(ctaId, mappedData, ctaName) {})
  .on("search", function() {});

//The new hub events can trigger before cihost scripts are loaded. This will ensure your scripts fire no matter what, but not more than once for 'load'.
if (!window.onbrandLoaded) {
  Hubs.Events.trigger("load");
}



// WEBPACK FOOTER //
// ./onbrand.js